module.exports = __webpack_public_path__ + "img/icon_map_63_off_010.8d23a84d.png";